import { Pipe, PipeTransform } from '@angular/core';

import { resolveEnterpriseDisplayName } from 'app/services/enterprise-context';

@Pipe({ name: 'enterpriseName' })
export class EnterpriseNamePipe implements PipeTransform {
    transform(value?: string | null): string {
        return resolveEnterpriseDisplayName(value);
    }
}
